import { useTranslation } from 'react-i18next';

import { Radio } from '@any-ui-react/core';

import { useUpdateRuleCombinator } from '../../hooks';
import { useConditionBuilderStore } from '../../store';
import { RuleCombinator } from '../../types';

export const ConditionTypeRadioSelector = () => {
  const combinator = useConditionBuilderStore((state) => state.condition.combinator);
  const disabled = useConditionBuilderStore((state) => state.disabled);
  const { t } = useTranslation('crm');

  const updateRule = useUpdateRuleCombinator();

  return (
    <Radio.Group
      className="mt-4"
      onChange={(value) => {
        updateRule(value as RuleCombinator);
      }}
      value={combinator}
    >
      <div className="flex w-full gap-x-2">
        <Radio
          className="text-xs"
          value={RuleCombinator.AND}
          label={t('crm.conditionBuilder.compactRadioCombinator', { type: RuleCombinator.AND })}
          disabled={disabled}
        />
        <Radio
          className="text-xs"
          value={RuleCombinator.OR}
          label={t('crm.conditionBuilder.compactRadioCombinator', { type: RuleCombinator.OR })}
          disabled={disabled}
        />
      </div>
    </Radio.Group>
  );
};
